/**
 * Default entity ATIs for Compass (1P).
 */
import type { CompassEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyCompassEntityATI = readonly CompassEntityATI[];

export const DEFAULT_COMPASS_ENTITY_ATI: ReadonlyCompassEntityATI = ['ati:cloud:compass:component'];
